import { BUTTON_HEIGHT_24 } from '../../../../Button'
import {
  TableSwitchCell,
  TableTextCell,
  TableUserCell,
} from '../../../../Table'
import {
  hasDocFlowAdditionalEmails,
  toRecipientArchivedMultiValue,
} from '../../../DocFlow.utils.recipients'
import { DocFlowEpostValidationPreviewButton } from '../../../DocFlowEpostValidationPreviewButton'
import { DocFlowSendingFieldName } from '../../DocFlowSending.constants'

import { RecipientContent } from './RecipientContent'

import * as styles from './DocFlowSendingEpostValidationErrorsReportModalRow.module.css'

export function renderCell({
  emptyCommunicationRecipients,
  item,
  name,
  saveToProfileIds,
  sendAdditionalEmailIds,
  sendEmailIds,
  t,
  onOpenValidationPreview,
  onToggleSaveToProfile,
  onToggleSendAdditionalEmail,
  onToggleSendEmail,
  ...restProps
}) {
  const { [name]: value } = item
  const recipientValue = item[DocFlowSendingFieldName.Recipient]?.[name]
  const hasError = emptyCommunicationRecipients.includes(item.id)
  const hasAdditionalEmails = hasDocFlowAdditionalEmails(item)

  switch (name) {
    case DocFlowSendingFieldName.Recipient:
      return (
        <TableUserCell
          {...restProps}
          Content={RecipientContent}
          className={styles.recipientCell}
          value={toRecipientArchivedMultiValue(value)}
        >
          <DocFlowEpostValidationPreviewButton
            height={BUTTON_HEIGHT_24}
            onClick={onOpenValidationPreview}
          />
        </TableUserCell>
      )

    case DocFlowSendingFieldName.SaveToProfile:
      return (
        <TableSwitchCell
          {...restProps}
          hasError={hasError}
          label={t('DocumentStapling.SendingTableSaveProfileTextKey')}
          value={saveToProfileIds?.[item.id] ?? value}
          onChange={onToggleSaveToProfile}
        />
      )

    case DocFlowSendingFieldName.SendEmail:
      return (
        <TableSwitchCell
          {...restProps}
          hasError={hasError}
          label={t('DocumentStapling.SendingTableSendEmailTextKey')}
          tooltip={
            !item.recipient.email &&
            t('DocumentStapling.SendingTableNoEmailTooltipKey')
          }
          value={sendEmailIds?.[item.id] ?? value}
          onChange={onToggleSendEmail}
        />
      )

    case DocFlowSendingFieldName.SendAdditionalEmail:
      return (
        <TableSwitchCell
          {...restProps}
          disabled={!hasAdditionalEmails}
          hasError={hasError}
          label={t('DocFlow.SendingTableSendAdditionalEmailTextKey')}
          tooltip={
            !hasAdditionalEmails &&
            t('DocFlow.SendingTableNoAdditionalEmailTooltipKey')
          }
          value={sendAdditionalEmailIds?.[item.id] ?? value}
          onChange={onToggleSendAdditionalEmail}
        />
      )

    case DocFlowSendingFieldName.SendEpost:
      return (
        <TableSwitchCell
          {...restProps}
          disabled
          label={t('DocFlow.SendingTableSendEpostTextKey')}
          tooltip={t('DocFlow.EpostValidationErrorsReportTableEpostTooltipKey')}
          value={false}
        />
      )

    case DocFlowSendingFieldName.Email:
      return <TableTextCell {...restProps} value={recipientValue} />
  }
}
